export const SET_FIELD = 'SET_FIELD';

export function setField(fieldname, value) {
  return {
    type: SET_FIELD,
    payload: { [fieldname]: value },
  };
}
